import { render } from "./WebVersionInfoM.vue?vue&type=template&id=537b8900&scoped=true"
import script from "./WebVersionInfoM.vue?vue&type=script&lang=js"
export * from "./WebVersionInfoM.vue?vue&type=script&lang=js"

import "./WebVersionInfoM.vue?vue&type=style&index=0&id=537b8900&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-537b8900"]])

export default __exports__